export const createBreweriesRequests = (client) => ({
    listBreweries: async (params) => {
        const { data, meta, links } = await client.api.get("breweries", {
            params: params,
        });
        return { data, meta, links };
    },
    findBrewery: async (params) => {
        const { data } = await client.api.get(`breweries/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createBrewery: async (payload) => {
        const { data } = await client.api.create("breweries", payload);
        return { data };
    },
    updateBrewery: async (payload) => {
        const { data } = await client.api.update(`breweries/${payload?.id}`, payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map